import { type IconName, iconPaths } from "./paths";

export type { IconName };

type Props = {
  name: IconName;
  /** 16（文中・ボタン）・20（見出し・ナビ）・28（空の状態・取り込みの入口） */
  size?: 16 | 20 | 28;
  className?: string;
  /** 読み上げる名前。飾りのときは付けない */
  label?: string;
};

export function Icon({ name, size = 16, className, label }: Props) {
  return (
    <svg
      className={className ? `ico ${className}` : "ico"}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      role={label ? "img" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      focusable="false"
      // biome-ignore lint/security/noDangerouslySetInnerHtml: 中身は paths.ts の固定の文字列だけ（利用者の入力は入らない）
      dangerouslySetInnerHTML={{ __html: iconPaths[name] }}
    />
  );
}
